import script from "./InfoPopUp.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoPopUp.vue?vue&type=script&setup=true&lang=js"

import "./InfoPopUp.vue?vue&type=style&index=0&id=d063404e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d063404e"]])

export default __exports__